import { z } from 'zod';
import { LEVELS, ROLES, CATEGORIES, DEFINITION_KINDS, define } from '../types.js';

/**
 * Auto-assign reference numbers for concierge return moves.
 */
export const schema = z.boolean();

export type AutoAssignRef = z.infer<typeof schema>;

export const definition = define({
  key: 'auto_assign_ref',
  schema,
  label: 'Auto-Assign Ref',
  description:
    'When clients at this level are creating a concierge return move, automatically assign its reference number to the related concierge pickup of this move.',
  kind: DEFINITION_KINDS.SETTING,
  category: CATEGORIES.REFERENCE_NUMBER.key,
  writableAtLevels: [LEVELS.HOPDRIVE, LEVELS.ORGANIZATION, LEVELS.CUSTOMER],
  readableByRoles: [ROLES.ADMIN],
  defaultValue: false,
});
